<template>
  <div class="handleShare">
    <van-popup v-if="isWX" v-model="isShowLinkMaskForWX" class="x-van-popup sharePanel-WSMask" @click="closeLinkMaskForWX('linkMaskForWX')">
      <img src="../assets/images/share.png" alt="分享链接">
    </van-popup>
  </div>
</template>

<script>
import { mixin_shareReward } from '../mixin/mixin'

export default {
  name: 'HandleShare',
  mixins: [mixin_shareReward],
  props: {
    shareConfig: {
      type: Object,
      default: null
    },
    appVersion: {
      type: Number,
      default: 0
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      shareState: false,
      isShowLinkMaskForWX: false,
      isApp: /jzh$/i.test(navigator.userAgent), // 是否是原生app
      isWX: /MicroMessenger/i.test(navigator.userAgent),
      isIOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent)
    }
  },
  watch: {
    'shareConfig.link' () {
      if (this.isWX) {
        this.setWeixinShare(this.shareConfig)
      }
    }
  },
  methods: {
    handleShare (way) {
      // 微信好友，在微信环境中分享h5链接蒙层右上角分享
      if (this.isWX && way === 'wechat') {
        this.isShowLinkMaskForWX = true
        return
      }
      // app中 微信好友和朋友圈分享
      if (this.isApp) {
        const { imgUrl, title, desc, link } = this.shareConfig
        // ### 1 默认设置（向后兼容）h5链接分享；scence:4 为qq
        const shareConfig_app = {
          shareType: 1, // 1.网页，2大图，3小程序 // 分享类型，默认h5链接
          agentKey: '', // 项目日志自定义统计key
          shareScence: 2, // 分享渠道,二进制转换 000000 ~ 111111。 timeline
          businessId: 2018, // 项目对于业务ID
          isOneKeyShare: true, // 是否一键分享,有多种分享渠道时应置为false
          title: title || '学而思网校送好礼啦',
          actionUrl: link || location.href, // 跳转url, 域名应以http或https开头开头
          description: desc || '好友邀你上名师课，注册即可领取',
          imagePath: imgUrl || 'https://activity.xueersi.com/topic/growth/common/images/common/xes-logo.png' // 图片地址

        }
        // app内微信修改shareScence: 1
        if (way === 'wechat') {
          shareConfig_app.shareScence = 1
          // 支持小程序，修改shareType: 3，设置小程序参数
          // 需做兼容分享h5 链接
          // 安卓8.9 版本后支持设置 分享小程序图片；iOS 分享小程序功能8.8 版本支持小程序。
          console.log('app version', this.appVersion)
          if ((!this.isIOS && this.appVersion >= 80900) || (this.isIOS && this.appVersion >= 80800)) {
            const shareConfig_miniProgram = {
              shareType: 3,
              wxMiniProgramType: 0, // 0，正式版:0，测试版:1，体验版:2
              wxMiniId: 'gh_1b6d03a727b2', // 小程序原始id
              iconUrl: 'https://zt.xueersi.com/apStatic/images/activiemini/mini-share.png', // 分享小程序出去的图片
              wxMiniPath: `/pages/oldNew/newTemplate?p=5f2ba716&sGroupId=20001&postType=4&inviteOldUserId=${this.userId}&sourceId=${window._wltfChannel.hotUrlParams.source || window._wltfChannel.urlParmas.source_id || ''}` // 小程序页面路径
            }
            Object.assign(shareConfig_app, shareConfig_miniProgram)
          }
        }
        this.callAppShare(shareConfig_app)
      }
    },
    // 调用app分享功能。支持：网页/链接，图片，小程序（ios版本有要求）
    callAppShare (shareConfig) {
      console.log('call app share. config：', shareConfig)
      xesApp.appShareBack = res => {
        console.log('app share back:', res)
        this.handleShareCallback()
        this.$xesLogger.clickMsg({ params: { clickid: '3.2.1.1', action: 'appShareBack', status: '1', shareScence: `${shareConfig.shareScence}` } })
      }
      xesApp.start('xesShare/share', JSON.stringify(shareConfig), 'xesApp.appShareBack')
    },
    // 微信分享设置
    setWeixinShare (config) {
      // 设置微信的分享链接。固定链接，调用一次就可以了
      console.log('set Weixin Share', config)
      if (!config.link) return
      xesShare.shareLink(config, res => {
        console.log('wexin share back:', res)
        this.handleShareCallback()
        this.$xesLogger.clickMsg({ params: { clickid: '3.2.1.2', action: 'wxShareBack', status: '1' } })
        // 分享回调结果(不区分成功和失败)
      }, () => console.log('取消微信分享'))
    },
    // 分享成功回调。分享的客户端。app：网校app。wx：微信环境
    handleShareCallback () {
      this.closeLinkMaskForWX()
      if (this.shareState) return
      this.shareState = true
      this.increaseShareCountForGold()
      setTimeout(() => { this.shareState = false }, 1000)
    },
    // 关闭 链接分享弹窗
    closeLinkMaskForWX () {
      this.isShowLinkMaskForWX = false
      this.$xesLogger.clickMsg({ params: { action: 'closeLinkMaskForWX', clickid: 'TODO' } })
    }
  }
}
</script>

<style lang="less" scoped>
// ## 链接分享遮罩
.handleShare {
  .sharePanel-WSMask {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    transform: unset;

    & > img {
      position: absolute;
      top: 20px;
      right: 42px;
      width: 274px;
    }
  }
}
</style>
